import { Iso8601Date } from "../Types";

export type DPAStatus = "WRITING" | "REQUESTED_SIGNATURES" | "ABANDONED" | "COMPLETED";

export type DPAAuthorType = "SELF_AUTHOR" | "USER_UPLOAD";

export type DPAType =
  | "DATA_SELLING" // DEPRECATED: use DATA_SELLING_GOOGLE_ANALYTICS (for GA) or DATA_SELLING_OTHER (all other vendors)
  | "DATA_SELLING_GOOGLE_ANALYTICS"
  | "DATA_SELLING_OTHER"
  | "TARGETED_ADVERTISING"
  | "SENSITIVE_DATA"
  | "PERSONAL_DATA_OF_CHILDREN"
  | "SNI"
  | "PROFILING";
export const dpaTypeToHumanReadable = (dpaType: DPAType) => {
  switch (dpaType) {
    case "DATA_SELLING":
      return "Data Selling";
    case "DATA_SELLING_GOOGLE_ANALYTICS":
      return "Data Selling - Google Analytics";
    case "DATA_SELLING_OTHER":
      return "Data Selling - Other";
    case "TARGETED_ADVERTISING":
      return "Targeted Advertising";
    case "SENSITIVE_DATA":
      return "Sensitive Data";
    case "PERSONAL_DATA_OF_CHILDREN":
      return "Personal Data of Children";
    case "PROFILING":
      return "Profiling";
    case "SNI":
      return "Data Selling - Shopify Network Intelligence";
  }
};

export interface DataProtectionAssessmentDto {
  id: string;
  name: string;
  type: DPAType;
  status: DPAStatus;
  authorType: DPAAuthorType | null;
  customPdfFilename: string | null;
  abandonedBy: string | null;
  copiedFromPreviousDpa: DataProtectionAssessmentDto | null;
  createdAt: Iso8601Date;
  completedAt?: Iso8601Date;
  abandonedAt?: Iso8601Date;
  abandonedNote?: string;
}

export interface CreateDataProtectionAssessmentRequest {
  name: string;
  dpaType: DPAType;
  copyFromPreviousDpa?: boolean;
}

export interface UpdateDataProtectionAssessmentRequest {
  name?: string;
  status?: DPAStatus;
  authorType?: DPAAuthorType | null;
}

export interface AbandonDataProtectionAssessmentRequest {
  abandonedNote?: string;
}

export type DPAApprovalPartyType = "INTERNAL" | "EXTERNAL";
export type DPAApprovalPartyStatus = "PENDING" | "SENT" | "SIGNED";
export type DPAApprovalPartyPurpose = "CONTRIBUTOR" | "SIGNER";

export const dpaApprovalPartyStatusToHumanReadable = (status: DPAApprovalPartyStatus) => {
  switch (status) {
    case "PENDING":
      return "Pending";
    case "SENT":
      return "Sent";
    case "SIGNED":
      return "Signed";
  }
};

export interface DPAPromptDto {
  id: string;
  title: string;
  helpText: string;
  sampleTextTargetedAdvertising?: string | null;
  sampleTextGoogleAnalytics?: string | null;
  sampleTextSni?: string | null;
  orderIndex: number;
  isOptional: boolean;
}

export interface DPAAnswerDto {
  id: string;
  answer: string;
  dpaPromptId: string;
}

export interface DPAApprovalPartyDto {
  id: string;
  dpaId: string;
  status: DPAApprovalPartyStatus;
  purpose: DPAApprovalPartyPurpose;
  partyType: DPAApprovalPartyType;
  name: string;
  title: string;
  email: string;
}

export interface AddDPAAnswerRequest {
  promptId: string;
  answer: string;
}

export interface AddDPAApprovalPartyRequest {
  name: string;
  title: string;
  email: string;
  purpose: DPAApprovalPartyPurpose;
  partyType: DPAApprovalPartyType;
}

export interface UpdateDPAApprovalPartyRequest {
  name?: string;
  title?: string;
  email?: string;
}
